import React, { Component } from 'react'
import moment from 'moment';
import { CURRENCY, Datos_Empresa, FORMAT_NUMBER, SYMBOL } from "../../libs/utils/Const";
import { development } from "../../libs/utils/Const";

class PaymentsReceived extends Component {

    render() {
        return (
            <div className='mt-5' style={{height :"auto", width:"90%", marginLeft: "auto", marginRight:"auto", marginBottom: "100px"}}>

                <div className="row">
                    <div className="col-3">
                        <img src={require('../../images/logo_EMPRESA.svg')} alt="Logo" />
                        <p className="text-center">{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br /><strong>{Datos_Empresa.RFC}</strong></p>
                        <span className="text-left">Teléfono(s):</span>
                        <p>COL. C.P.;,.</p>
                    </div>
                    <div className="col-9"></div>
                </div>
                <div className='row mt-4' style={{ paddingRight: "15px" }}>
                    
                    <table>
                        <tbody>
                            <tr>
                                <td><strong>CLIENTE: </strong>CCC676</td>
                                <td><strong>FECHA: </strong>2022-06-30 18:34:42</td>
                            </tr>
                            <tr>
                                <td><strong>NOMBRE: </strong>ROLLER HOUSE MEXICO SA DE CV</td>
                                <td><strong>CONDICIÓN DE PAGO: </strong>FACTURA BASE</td>
                                
                            </tr>
                            <tr>
                                <td><strong>RUT: </strong>RHM160706LT4</td>
                                <td><strong>MONEDA: </strong>0 $</td>
                                
                            </tr>
                            <tr>
                                <td><strong>DIRECCION: </strong>C. AV. LA MARINA, No. 411, Int. LOCAL4, Col. EL TOREO, Del. MAZATLAN C</td>
                                <td colSpan="2"><strong>LUGAR DE ENTREGA: </strong>C. .., No. ., Int. .., ., SIN, MX</td>
                                
                            </tr>
                            <tr>
                                <td><strong>CIUDAD: </strong>MAZATLAN, SIN</td>
                            </tr>
                            <tr>
                                <td><strong>PAÍS: </strong>MX <strong> C.P.: </strong>82120</td>
                            </tr>
                            
                            <tr>
                                <td><strong>TELEFONO: </strong>7759873456</td>
                            </tr>
                            <tr>
                                <td colSpan="2"><strong>CONTACTO: </strong>C. .., No. ., Int. .., ., SIN, MX</td>
                            </tr>
                        </tbody>
                    </table>
                    <table className='mt-5'>
                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                            <tr>
                                <th className="text-center">DOCUMENTO</th>
                                <th className="text-center">TIPO.</th>
                                <th className="text-center">FECHA</th>
                                <th className="text-right">TOTAL</th>
                                <th className="text-right">SALDO VENCIDO</th>
                                <th className="text-right">PAGO TOTAL</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="text-center">356</td>
                                <td className="text-center">Factura</td>
                                <td className="text-center">2022-10-04</td>
                                <td className="text-right mr-2">75.41</td>
                                <td className="text-right mr-2">0.00</td>
                                <td className="text-right mr-2">75.41</td>
                            </tr>
                        </tbody>
                    </table>
                    <table className='mt-5'>
                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                            <tr>
                                <th className="text-center">TIPO DE PAGO</th>
                                <th className="text-center">FECHA</th>
                                <th className="text-center">CUENTA DE MAYOR</th>
                                <th className="text-center">REFERENCIA / No.CHEQUE / No.VOUCHER / CUENTA</th>
                                <th className="text-right">MONTO</th>
                                
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="text-center">Efectivo</td>
                                <td className="text-center">2022-10-04</td>
                                <td className="text-center">11101000</td>
                                <td className="text-center">--</td>
                                <td className="text-right mr-2">75.41</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className='row mt-3'>
                    <div className='col-9'>
                        <p>
                            <br />
                            Importe con letra: <br />
                            SETENTA Y CINCO SOLES CON CUARENTA Y UN CENTAVOS.<br />
                            <br />
                            <br />
                        </p>
                    </div>
                    <div className='col-3'>
                        <table>

                            <tbody>
                                <tr>
                                    <td className='text-right'><strong>Pago a cuenta: </strong></td>
                                    <td className='text-right mr-2'>0.00</td>
                                </tr>
                                <tr>
                                    <td className='text-right'><strong>Saldo vencido: </strong></td>
                                    <td className='text-right mr-2'>0.00</td>
                                </tr>
                                <tr>
                                    <td className='text-right'><strong>Total: </strong></td>
                                    <td className='text-right mr-2'>75.41</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <br />
                <br />
                <br />
            </div>
              
        )
    }
}

export default PaymentsReceived